import React from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Flex, Tag, Tooltip } from 'antd';
import { addDays, differenceInDays, startOfDay } from 'date-fns';

import { ClosureRequest, closureRequestStatuses } from '../types';
import { getReasonLabel } from './StartOrCancelClosureProcedure/FormContent';

const CLOSURE_DELAY_DAYS = 90;

export const ClosureRequestCountdown = ({
  closureRequest,
}: {
  closureRequest: ClosureRequest | undefined | null;
}) => {
  if (!closureRequest) {
    return null;
  }

  const { status, approved_at } = closureRequest;

  if (closureRequestStatuses.Approved !== status || !approved_at) {
    return null;
  }

  const closureDate = startOfDay(
    addDays(new Date(approved_at), CLOSURE_DELAY_DAYS + 1)
  );
  const daysLeft = differenceInDays(closureDate, new Date());

  if (daysLeft <= 0) {
    return (
      <Tag
        data-testid="tag-closure-imminent"
        icon={<ExclamationCircleOutlined />}
        color="red"
        style={{ width: 'fit-content' }}
      >
        Anonymization within 24 hours
      </Tag>
    );
  }

  return (
    <Tooltip
      title={
        <Flex gap="medium" vertical>
          <span>Closure date: {closureDate.toLocaleDateString()}</span>
          <span>Reason: {getReasonLabel(closureRequest.reason)}</span>
          {closureRequest.details && (
            <span>Details: {closureRequest.details}</span>
          )}
        </Flex>
      }
      placement="bottom"
    >
      <Tag
        data-testid="tag-closure-countdown"
        icon={<ExclamationCircleOutlined />}
        color="orange"
        style={{ width: 'fit-content' }}
      >
        Anonymization within {daysLeft} day{daysLeft > 1 ? 's' : ''}
      </Tag>
    </Tooltip>
  );
};
